import { backendApi } from "./backendApi.rtkq";

export interface AdminUser {
  id: string;
  firebaseUid: string;
  email: string;
  displayName: string;
  isSuperAdmin: boolean;
  isDisabled: boolean;
  lastLoginAt?: string;
  createdAt: string;
  offices: {
    officeId: string;
    officeName: string;
    role: string;
  }[];
}

export const adminUsersApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminUsers: builder.query<AdminUser[], void>({
      query: () => "/admin/pg-users",
      providesTags: ["Users"],
    }),

    updateAdminUser: builder.mutation<any, { id: string; updates: { isSuperAdmin?: boolean; isDisabled?: boolean; displayName?: string } }>({
      query: ({ id, updates }) => ({
        url: `/admin/pg-users/${id}`,
        method: "PUT",
        body: updates,
      }),
      invalidatesTags: ["Users"],
    }),

    deleteAdminUser: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({ url: `/admin/pg-users/${id}`, method: "DELETE" }),
      invalidatesTags: ["Users", "Accounts"],
    }),
  }),
});

export const {
  useGetAdminUsersQuery,
  useUpdateAdminUserMutation,
  useDeleteAdminUserMutation,
} = adminUsersApi;
